import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = { selector: String }

    declare readonly selectorValue: string
    declare readonly hasSelectorValue: boolean

    open(event: Event) {
        event.preventDefault()

        const selector = this.hasSelectorValue ? this.selectorValue : this.element.getAttribute('href') || ''
        if (!selector) {
            return
        }

        const modal = document.querySelector(selector)
        if (!modal) {
            return
        }

        modal.dispatchEvent(new CustomEvent('modal:open', { bubbles: true }))
    }
}
